import Vue from 'vue'
import Router from 'vue-router'
import  Store  from '../store/index'

// Auth
import Signin from '@/components/auth/Signin'
import forgotPassword from '@/components/auth/forgotPassword'
import Signup from '@/components/auth/Signup'
import Reset from '@/components/auth/Reset'
import Authentication from '@/components/auth/Authentication'
import Logout from '@/components/auth/Logout'

// Dashboard
import FeatureRequests from '@/components/dashboard/communityBoard/featureRequests'
import UpgradePlan from '@/components/dashboard/communityBoard/upgradePlan'
import UpgradeShopify from '@/components/dashboard/UpgradeShopify'
import BugReports from '@/components/dashboard/communityBoard/bugReports'

import Accounts from '@/components/dashboard/Accounts'
    import AccountsTwitter from '@/components/dashboard/accounts/twitter'
    import AccountsFacebook from '@/components/dashboard/accounts/facebook'
    import AccountsInstagram from '@/components/dashboard/accounts/instagram'
    import AccountsShopify from '@/components/dashboard/accounts/shopify'
    import AccountsYoutube from '@/components/dashboard/accounts/youtube'
    import AccountsGooglePlay from '@/components/dashboard/accounts/googlePlay'
    import AccountsAppStore from '@/components/dashboard/accounts/appStore'
    import AccountsWhatsApp from '@/components/dashboard/accounts/whatsApp'
    import AccountsGmail from '@/components/dashboard/accounts/gmail'
    import AccountsLinkedin from '@/components/dashboard/accounts/linkedin'
    import accountsGoogleMyBusiness from '@/components/dashboard/accounts/googleMyBusiness'
    import AccountsEmail from '@/components/dashboard/accounts/email'
    import AccountsTrustPilot from '@/components/dashboard/accounts/trustPilot'

import Audience from '@/components/dashboard/Audience'
import Team from '@/components/dashboard/Team'
import Account from '@/components/dashboard/EditUser'
import Workspace from '@/components/dashboard/Workspace'
import Chatconfig from '@/components/dashboard/Chatconfig'
import Widget from '@/components/dashboard/Widget'
import WhiteLabel from '@/components/dashboard/WhiteLabel'
import Statistics from '@/components/dashboard/Statistics'
import Inbox from '@/components/dashboard/Inbox'
import Inbox2 from '@/components/dashboard/Inbox2'
import Introduction from '@/components/dashboard/introduction'
import CreateTeam from '@/components/dashboard/createTeam'
import IntroductionTeam from '@/components/dashboard/introductionTeam'
import IntroductionPage from '@/components/dashboard/introductionPage'
import Notifications from '@/components/dashboard/Notifications'
import EmailRender from '@/components/dashboard/emailRender'
import UpgradeV2 from '@/components/dashboard/UpgradeV2'
import trackingCode from '@/components/dashboard/trackingCode'
import Export from '@/components/dashboard/export'
import ChatBotDemo from '@/components/dashboard/ChatbotDemo'

import Campaigns from '@/components/dashboard/Campaign'
import KnowledgeBase from '@/components/dashboard/KnowledgeBase'

Vue.use(Router)


  let router = new Router({
  mode: 'history',
  routes: [
    {
        "path": "/signup",
        "name": "signup",
        "meta": { "layout": "onepageViewNoAuth" },
        "component": Signup
    },
    {
        "path": "/reset",
        "name": "reset",
        "meta": { "layout": "onepageViewNoAuth" },
        "component": Reset
    },
    {
        "path": "/logout",
        "name": "logout",
        "meta": { "layout": "onepageViewNoAuth" },
        "component": Logout
    },
    {
        "path": "/signin",
        "name": "signin",
        "meta": { "layout": "onepageViewNoAuth" },
        "component": Signin
    },
    {
        "path": "/forgot",
        "name": "forgotPassword",
        "meta": { "layout": "onepageViewNoAuth" },
        "component": forgotPassword
    },
    {
        "path": "/authentication",
        "name": "authentication",
        "meta": { "layout": "onepageViewNoAuth" },
        "component": Authentication
    },
    {
        "path": "/upgrade-plan",
        "name": "UpgradePlan",
        "component": UpgradePlan,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },
    {
        "path": "/community/feature-requests",
        "name": "featureRequests",
        "component": FeatureRequests,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },
    {
        "path": "/community/bug-reports",
        "name": "bugReports",
        "component": BugReports,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },
    {
        "path": "/introduction/team",
        "name": "introductionTeam",
        "component": IntroductionTeam,
        "meta": { 
            "requiresAuth": true,
            "layout": "onepageView"
          }
    },
    {
        "path": "/introduction/page",
        "name": "introductionPage",
        "component": IntroductionPage,
        "meta": { 
            "requiresAuth": true,
            "layout": "onepageView"
          }
    },
    {
        "path": "/introduction",
        "name": "introduction",
        "component": Introduction,
        "meta": { 
            "requiresAuth": true,
            "layout": "onepageView"
          }
    },
    {
        "path": "/",
        "component": Accounts,
        "children": [{
            "path": "",
            "component": AccountsFacebook
        }],
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/accounts",
        "name": "accounts",
        "component": Accounts,
        "children": [{
            "path": "",
            "component": AccountsFacebook
        },{
            "path": "twitter",
            "name": "accountsTwitter",
            "component": AccountsTwitter
        },{
            "path": "facebook",
            "name": "accountsFacebook",
            "component": AccountsFacebook
        },{
            "path": "instagram",
            "name": "accountsInstagram",
            "component": AccountsInstagram
        },{
            "path": "shopify",
            "name": "accountsShopify",
            "component": AccountsShopify
        },{
            "path": "youtube",
            "name": "accountsYoutube",
            "component": AccountsYoutube
        },{
            "path": "googleplay",
            "name": "accountsGooglePlay",
            "component": AccountsGooglePlay
        },{
            "path": "appstore",
            "name": "accountsAppStore",
            "component": AccountsAppStore
        },{
            "path": "email",
            "name": "accountsEmail",
            "component": AccountsEmail
        },{
            "path": "trustpilot",
            "name": "accountsTrustPilot",
            "component": AccountsTrustPilot
        },{
            "path": "gmail",
            "name": "accountsGmail",
            "component": AccountsGmail
        },{
            "path": "linkedin",
            "name": "accountsLinkedin",
            "component": AccountsLinkedin
        },
        {
            "path": "googlemybusiness",
            "name": "accountsGoogleMyBusiness",
            "component": accountsGoogleMyBusiness
        },
        {
            "path": "whatsapp",
            "name": "accountsWhatsApp",
            "component": AccountsWhatsApp
        }],
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/upgrade-shopify",
        "name": "UpgradeShopify",
        "component": UpgradeShopify,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/upgrade",
        "name": "UpgradeV2",
        "component": UpgradeV2,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/tracking",
        "name": "trackingCode",
        "component": trackingCode,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/team",
        "name": "team",
        "component": Team,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/audience",
        "name": "audience",
        "component": Audience,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/knowledge-base",
        "name": "knowledgeBase",
        "component": KnowledgeBase,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/campaigns",
        "name": "campaigns",
        "component": Campaigns,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/export",
        "name": "export",
        "component": Export,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/account",
        "name": "account",
        "component": Account,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/workspace",
        "name": "workspace",
        "component": Workspace,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/config",
        "name": "config",
        "component": Chatconfig,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/whitelabel",
        "name": "whitelabel",
        "component": WhiteLabel,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },
    {
        "path": "/notifications",
        "name": "Notifications",
        "component": Notifications,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },
    {
        "path": "/emailrender",
        "name": "emailRender",
        "component": EmailRender,
        "meta": { 
            "requiresAuth": true,
            "layout": "leanView"
          }
    },
    {
        "path": "/createTeam",
        "name": "createTeam",
        "component": CreateTeam,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/statistics",
        "name": "statistics",
        "component": Statistics,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/widget",
        "name": "Widget",
        "component": Widget,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },{
        "path": "/inbox",
        "name": "inbox",
        "component": Inbox,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },
    {
        "path": "/inbox2",
        "name": "inbox2",
        "component": Inbox2,
        "meta": { 
            "requiresAuth": true,
            "layout": "sidebarView"
          }
    },
    {
        "path": "*",
        "component": Accounts
    },
    {
        "path": "/juphy-ai",
        "name": "chatbotdemo",
        "component": ChatBotDemo,
        "meta": {
            "requiresAuth": true,
            "layout": "onepageView"
        }
    }
  ]
})


router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
      if (Store.getters['session/isLoggedIn']) {
        next()
        return
      }
      next('/signin') 
    } else {
      next() 
    }
  })

export default router


// WEBPACK FOOTER //
// ./src/router/index.js